import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ValidityFormService {
	valid: Subject<boolean> = new Subject();

	setValidity(validity: boolean) {
		this.valid.next(validity);
	}
}
